import { currencyFractionDigits } from '../../../shared/utils/commercial-money';
import { TranslocoPipe } from '@jsverse/transloco';
import { AccountingDirectoryControlsComponent } from '../../shared/accounting-directory-controls.component';
import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from "primeng/api";
import { FinancePdfViewButtonComponent } from '../../finance-pdf-view-button.component';
import { AccountsService } from "../../accounts.service";
import { SessionStorageService } from "../../../services/session-storage.service";
import * as XLSX from "xlsx";
import { Bill } from "./bill.model";
import { canEditNonPoBillDraft } from './bill-edit-eligibility';
import { BillLine } from "./bill-line.model";
import { Router } from '@angular/router';
import { TableLazyLoadEvent, TableModule } from "primeng/table";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MultiSelectModule } from 'primeng/multiselect';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { ToastModule } from "primeng/toast";
import { ProgressBarModule } from "primeng/progressbar";
import { PanelModule } from "primeng/panel";
import { ImageModule } from "primeng/image";
import { InputGroupModule } from "primeng/inputgroup";
import { InputGroupAddonModule } from "primeng/inputgroupaddon";
import { IftaLabelModule } from "primeng/iftalabel";
import { DrawerModule } from "primeng/drawer";
import { SelectModule } from "primeng/select";
import { InputNumberModule } from "primeng/inputnumber";
import { PermissionService } from '../../../security/permission.service';
import { app_permissions } from '../../../security/app-permissions';
import { PageShellComponent } from '../../../shared/page-layout/page-shell.component';
import { PageHeroComponent } from '../../../shared/page-layout/page-hero.component';
import { PageMetricStripComponent } from '../../../shared/page-layout/page-metric-strip.component';
import { PageSearchPanelComponent } from '../../../shared/page-layout/page-search-panel.component';
import { PageDataPanelComponent } from '../../../shared/page-layout/page-data-panel.component';
import { PageMetric } from '../../../shared/page-layout/page-layout.models';
import { CompanyScopeSelection, CompanyScopeSelectorComponent } from '../../company-scope-selector/company-scope-selector.component';
import { CRM_PAYABLE_ROLES, CrmPartyContextService } from '../../../shared/crm-client-contact-picker/crm-party-context.service';
import { finalize } from 'rxjs';
import { PendingActionTracker } from '../../../shared/state/pending-action-tracker';



@Component({
    selector: 'app-generated-bills',
    templateUrl: './generated-bills.component.html',
    styleUrls: ['../../finance-list.shared.css', './generated-bills.component.css'],
    standalone: true,
    imports: [FinancePdfViewButtonComponent, TranslocoPipe,
        CommonModule,
        FormsModule,
        BreadcrumbModule,
        TableModule,
        MultiSelectModule,
        DatePickerModule,
        InputTextModule,
        ButtonModule,
        CardModule,
        TooltipModule,
        TagModule,
        ToastModule,
        ProgressBarModule,
        PanelModule,
        ImageModule,
        InputGroupModule,
        InputGroupAddonModule,
        IftaLabelModule,
        DrawerModule,
        SelectModule,
        InputNumberModule,
        PageShellComponent,
        PageHeroComponent,
        PageMetricStripComponent,
        PageSearchPanelComponent,
        PageDataPanelComponent,
        AccountingDirectoryControlsComponent,
        CompanyScopeSelectorComponent
    ],
    providers: [
        MessageService,
        AccountsService,
        SessionStorageService
    ]
})
export class GeneratedBillsComponent implements OnInit {
    readonly pendingStatuses = ['DRAFT', 'SUBMITTED', 'APPROVED', 'ON_HOLD'];
    searchText = '';
    directoryMode: 'LIST' | 'CRM' | 'PARTY_TYPE' = 'LIST';
    directoryFilters: Record<string, string | number | boolean | number[] | string[] | null | undefined> = {};
    private listRequestId = 0;

    readonly documentActions = new PendingActionTracker<number | undefined>();

    isLoading = false;

    breadcrumbItems: MenuItem[] = [];
    homeBreadcrumb: MenuItem = {};

    // Data properties for the unified table
    allBills: Bill[] = [];
    selectedBills: Bill[] = [];
    totalRecords: number = 0;
    first: number = 0;
    rows: number = 20;

    // Filter properties
    clients: any[] = [];
    selectedClients: any[] = [];
    dateRange: (Date | null)[] | null = null;
    statuses: { label: string, value: string }[] = [
        { label: 'Draft', value: 'DRAFT' },
        { label: 'Submitted', value: 'SUBMITTED' },
        { label: 'Approved', value: 'APPROVED' },
        { label: 'On hold', value: 'ON_HOLD' },
        { label: 'Posted', value: 'POSTED' },
        { label: 'Paid', value: 'PAID' },
        { label: 'Partially Paid', value: 'PARTIALLY_PAID' },
        { label: 'Unpaid', value: 'UNPAID' },
        { label: 'On hold', value: 'ON_HOLD' },
        { label: 'Reversed', value: 'REVERSED' }
    ];
    selectedStatuses: string[] = [];
    documentStatuses = [
        { label: 'Draft', value: 'DRAFT' },
        { label: 'Submitted', value: 'SUBMITTED' },
        { label: 'Approved', value: 'APPROVED' },
        { label: 'Posted', value: 'POSTED' },
        { label: 'On hold', value: 'ON_HOLD' },
        { label: 'Cancelled', value: 'CANCELLED' },
        { label: 'Voided', value: 'VOIDED' },
        { label: 'Reversed', value: 'REVERSED' },
        { label: 'Closed', value: 'CLOSED' }
    ];
    selectedDocumentStatuses: string[] = this.pendingStatuses.slice();
    workflowStatuses = [
        { label: 'Draft', value: 'DRAFT' },
        { label: 'Submitted', value: 'SUBMITTED' },
        { label: 'Approved', value: 'APPROVED' },
        { label: 'Rejected', value: 'REJECTED' },
        { label: 'On hold', value: 'ON_HOLD' },
        { label: 'Released', value: 'RELEASED' }
    ];
    selectedWorkflowStatuses: string[] = [];
    postingStatuses = [
        { label: 'Not posted', value: 'NOT_POSTED' },
        { label: 'Posted', value: 'POSTED' },
        { label: 'Reversed', value: 'REVERSED' }
    ];
    selectedPostingStatuses: string[] = [];
    dueStatusOptions = [
        { label: 'Open', value: 'OPEN' },
        { label: 'Overdue', value: 'OVERDUE' },
        { label: 'Current', value: 'CURRENT' },
        { label: 'No due date', value: 'NO_DUE_DATE' }
    ];
    selectedDueStatus: string | null = null;
    matchStatusOptions = [
        { label: 'Not required', value: 'NOT_REQUIRED' },
        { label: 'Pending match', value: 'PENDING_MATCH' },
        { label: 'Pending receipt', value: 'PENDING_RECEIPT' },
        { label: 'Matched', value: 'MATCHED' },
        { label: 'Exception', value: 'MATCH_EXCEPTION' },
        { label: 'Override approved', value: 'OVERRIDE_APPROVED' }
    ];
    selectedMatchStatuses: string[] = [];
    paymentHoldOptions = [
        { label: 'Held only', value: true },
        { label: 'Not held only', value: false }
    ];
    selectedPaymentHold: boolean | null = null;
    vendorInvoiceNumberFilter: string | null = null;
    currencyCodeFilter: string | null = null;
    amountMinFilter: number | null = null;
    amountMaxFilter: number | null = null;
    billNumberFilter: string | null = null;

    // Summary Card properties
    totalUnpaidAmount: number = 0;
    totalPaidAmount: number = 0;
    reportCurrencyCode: string = 'USD';

    canGenerateVoucher = false;
    canEditBill = false;
    previewBill: Bill | null = null;
    isPreviewVisible = false;
    currentScope: CompanyScopeSelection | null = null;

    get isConsolidatedReadOnly(): boolean {
        return !!this.currentScope?.readOnly;
    }

    constructor(
        private accountsService: AccountsService,
        private messageService: MessageService,
        private sessionStorageService: SessionStorageService,
        private permissionService: PermissionService,
        private router: Router,
        public crmPartyContext: CrmPartyContextService
    ) { }


    ngOnInit(): void {
        this.canGenerateVoucher = this.permissionService.hasPermission(app_permissions.accounts.voucher.create);
        this.canEditBill = this.permissionService.hasPermission(app_permissions.accounts.bill.edit);

        this.breadcrumbItems = [{ label: 'Accounts' }, { label: 'Enterprise' }, { label: 'Payables' }, { label: 'Generated Bills' }];
        this.homeBreadcrumb = { icon: 'pi pi-home', routerLink: '/' };
        this.loadInitialData();
    }

    onScopeChange(scope: CompanyScopeSelection) {
        this.currentScope = scope;
        this.selectedBills = [];
        this.applyFilters();
    }

    loadInitialData() {
        this.isLoading = true;
        const companyId = this.sessionStorageService.getCompany()?.id;
        if (!companyId) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Company not found.' });
            this.isLoading = false;
            return;
        }

        this.crmPartyContext.loadClients(companyId, CRM_PAYABLE_ROLES).subscribe(clients => {
            this.clients = clients.map(client => ({ ...client, name: this.crmPartyContext.clientName(client) }));
        });

        // Initial data load for the table and summary is triggered by applyFilters
        this.applyFilters();
    }


    loadData(event: TableLazyLoadEvent) {
        this.isLoading = true;
        const requestId = ++this.listRequestId;
        this.first = event.first ?? 0;
        this.rows = event.rows ?? 20;

        const sessionCompanyId = this.sessionStorageService.getCompany()?.id;
        const companyGroupId = this.currentScope?.companyGroupId;
        const companyId = companyGroupId ? undefined : (this.currentScope?.companyId ?? sessionCompanyId);
        if (!companyId && !companyGroupId) return;

        const clientIds = this.selectedClients.map(c => Number(c.id?.entityId ?? c.id)).filter(Boolean);
        const startDate = this.dateRange?.[0] ? this.dateRange[0].toISOString() : undefined;
        const endDate = this.dateRange?.[1] ? this.dateRange[1].toISOString() : undefined;

        this.directoryFilters = { companyId, companyGroupId, clientIds, startDate, endDate, billNumber: this.billNumberFilter, paymentStatuses: this.selectedStatuses, workflowStatuses: this.selectedWorkflowStatuses, postingStatuses: this.selectedPostingStatuses, dueStatus: this.selectedDueStatus, matchStatuses: this.selectedMatchStatuses, paymentHold: this.selectedPaymentHold, vendorInvoiceNumber: this.vendorInvoiceNumberFilter, currencyCode: this.currencyCodeFilter, amountMin: this.amountMinFilter, amountMax: this.amountMaxFilter, searchText: this.searchText };

        this.accountsService.getGeneratedBills(
            this.first / this.rows,
            this.rows,
            companyId,
            clientIds,
            [],
            startDate,
            endDate,
            this.billNumberFilter ?? undefined,
            {
                paymentStatuses: this.selectedStatuses,
                documentStatuses: this.selectedDocumentStatuses,
                workflowStatuses: this.selectedWorkflowStatuses,
                postingStatuses: this.selectedPostingStatuses,
                dueStatus: this.selectedDueStatus ?? undefined,
                matchStatuses: this.selectedMatchStatuses,
                paymentHold: this.selectedPaymentHold ?? undefined,
                vendorInvoiceNumber: this.vendorInvoiceNumberFilter ?? undefined,
                currencyCode: this.currencyCodeFilter ?? undefined,
                amountMin: this.amountMinFilter ?? undefined,
                amountMax: this.amountMaxFilter ?? undefined
            },
            companyGroupId,
            this.searchText
        ).subscribe({
            next: (dataWrapper) => {
                if (requestId !== this.listRequestId) return;
                this.allBills = dataWrapper.items.map(i => ({
                    ...i,
                    status: this.getBillStatus(i)
                }));
                this.totalRecords = dataWrapper.count;
                this.isLoading = false;
                this.reportCurrencyCode = this.allBills.map(bill => bill.country?.currencyCode)?.at(0) ?? 'USD';
            },
            error: (err) => {
                if (requestId !== this.listRequestId) return;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not load bills.' });
                this.isLoading = false;
            }
        });

        // NOTE: This assumes 'getGeneratedBillsSummary' is updated to handle filters for accurate summary cards.
        this.accountsService.getGeneratedBillsSummary(
            companyId,
            clientIds,
            [],
            startDate,
            endDate,
            this.billNumberFilter ?? undefined,
            {
                paymentStatuses: this.selectedStatuses,
                documentStatuses: this.selectedDocumentStatuses,
                workflowStatuses: this.selectedWorkflowStatuses,
                postingStatuses: this.selectedPostingStatuses,
                dueStatus: this.selectedDueStatus ?? undefined,
                matchStatuses: this.selectedMatchStatuses,
                paymentHold: this.selectedPaymentHold ?? undefined,
                vendorInvoiceNumber: this.vendorInvoiceNumberFilter ?? undefined,
                currencyCode: this.currencyCodeFilter ?? undefined,
                amountMin: this.amountMinFilter ?? undefined,
                amountMax: this.amountMaxFilter ?? undefined
            },
            companyGroupId
        ).subscribe(summary => {
                if (requestId !== this.listRequestId) return;
            this.totalPaidAmount = (summary as any).totalPaidAmount || (summary as any).totalPaid || 0;
            this.totalUnpaidAmount = (summary as any).totalUnpaidAmount || (summary as any).totalDue || 0;
        });
    }

    getBillStatus(bill: Bill): string {
        if (bill.paymentStatus) {
            return bill.paymentStatus;
        }
        if (bill.allocationStatus) {
            return bill.allocationStatus;
        }
        const paidAmount = this.getPaidAmount(bill);
        const totalAmount = bill.totalAmount || 0;

        if (paidAmount >= totalAmount) {
            return 'PAID';
        } else if (paidAmount > 0 && paidAmount < totalAmount) {
            return 'PARTIALLY_PAID';
        } else {
            return 'UNPAID';
        }
    }

    getDeliveryNumbers(bill: Bill): string[] {
        const numbers = new Set<string>();
        for (const line of bill.billLines ?? []) {
            for (const reference of [line.detailReferenceNumber, line.headerReferenceNumber]) {
                const deliveryNumber = /^DLR\/\d{4}\/\d{2}\/\d+(?=\/|$)/.exec(reference?.trim() ?? '')?.[0];
                if (deliveryNumber) {
                    numbers.add(deliveryNumber);
                    break;
                }
            }
        }
        return [...numbers];
    }

    onDirectoryModeChange(mode: 'LIST' | 'CRM' | 'PARTY_TYPE'): void {
        this.directoryMode = mode;
        this.selectedBills = [];
    }

    onDirectorySearch(value: string): void {
        this.searchText = value;
        this.selectedBills = [];
        this.applyFilters();
    }

    showPendingStatuses(): void {
        this.selectedDocumentStatuses = this.pendingStatuses.slice();
        this.applyFilters();
    }

    showAllStatuses(): void {
        this.selectedDocumentStatuses = [];
        this.applyFilters();
    }

    applyFilters() {
        // Reset to the first page when applying filters
        this.loadData({ first: 0, rows: this.rows });
    }

    clearFilters() {
        this.selectedClients = [];
        this.dateRange = null;
        this.selectedStatuses = [];
        this.selectedDocumentStatuses = this.pendingStatuses.slice();
        this.selectedWorkflowStatuses = [];
        this.selectedPostingStatuses = [];
        this.selectedDueStatus = null;
        this.selectedMatchStatuses = [];
        this.selectedPaymentHold = null;
        this.vendorInvoiceNumberFilter = null;
        this.currencyCodeFilter = null;
        this.amountMinFilter = null;
        this.amountMaxFilter = null;
        this.billNumberFilter = null;
        this.searchText = '';
        this.applyFilters();
    }

    get metrics(): PageMetric[] {
        return [
            { label: 'Open AP', value: this.formatMoney(this.totalUnpaidAmount || this.currentPageOpenAmount()), hint: 'Filtered payable balance', tone: 'danger' },
            { label: 'Overdue AP', value: this.formatMoney(this.currentPageOverdueAmount()), hint: 'Current page overdue open bills', tone: 'warn' },
            { label: 'Due this week', value: this.formatMoney(this.currentPageDueThisWeekAmount()), hint: 'Current page bills due within 7 days', tone: 'info' },
            { label: 'Awaiting approval', value: this.currentPageCount(bill => bill.documentStatus === 'SUBMITTED' || bill.workflowStatus === 'SUBMITTED'), hint: 'Current page approval queue', tone: 'warn' },
            { label: 'Duplicate warnings', value: this.currentPageCount(bill => !!bill.duplicateWarning), hint: 'Current page duplicate vendor invoice warnings', tone: 'danger' },
            { label: 'Payment-held amount', value: this.formatMoney(this.currentPagePaymentHeldAmount()), hint: 'Current page held bills', tone: 'warn' }
        ];
    }

    get activeFilterCount(): number {
        return [
            this.selectedClients.length,
            this.dateRange?.some(Boolean) ? 1 : 0,
            this.selectedStatuses.length,
            this.selectedDocumentStatuses.length,
            this.selectedWorkflowStatuses.length,
            this.selectedPostingStatuses.length,
            this.selectedDueStatus ? 1 : 0,
            this.selectedMatchStatuses.length,
            this.selectedPaymentHold !== null ? 1 : 0,
            this.vendorInvoiceNumberFilter ? 1 : 0,
            this.currencyCodeFilter ? 1 : 0,
            this.amountMinFilter !== null ? 1 : 0,
            this.amountMaxFilter !== null ? 1 : 0,
            this.billNumberFilter ? 1 : 0
        ].reduce((total, value) => total + Number(value), 0);
    }

    get resultText(): string {
        return `${this.totalRecords} bills`;
    }

    getSelectedTotal(): number {
        return this.selectedBills.reduce((total, bill) => total + (bill.totalAmount || 0), 0);
    }

    getPaidAmount(bill: Bill): number {
        return bill.allocatedAmount ?? bill.vouchers?.reduce((acc, voucher) => acc + (voucher.allocatedAmount ?? voucher.amount ?? 0), 0) ?? 0;
    }

    getOpenAmount(bill: Bill): number {
        return bill.openAmount ?? Math.max(0, (bill.totalAmount || 0) - this.getPaidAmount(bill));
    }

    getBeforeTaxAmount(bill: Bill): number | null {
        return bill.dueAmount ?? (bill.totalAmount != null && bill.taxAmount != null
            ? bill.totalAmount - bill.taxAmount : null);
    }

    currentPageOpenAmount(): number {
        return this.allBills.reduce((total, bill) => total + this.getOpenAmount(bill), 0);
    }

    currentPageOverdueAmount(): number {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return this.allBills
            .filter(bill => bill.dueDate && new Date(bill.dueDate).getTime() < today.getTime() && this.getOpenAmount(bill) > 0)
            .reduce((total, bill) => total + this.getOpenAmount(bill), 0);
    }

    currentPageDueThisWeekAmount(): number {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const nextWeek = new Date(today);
        nextWeek.setDate(today.getDate() + 7);
        return this.allBills
            .filter(bill => {
                if (!bill.dueDate || this.getOpenAmount(bill) <= 0) return false;
                const dueDate = new Date(bill.dueDate);
                return dueDate >= today && dueDate <= nextWeek;
            })
            .reduce((total, bill) => total + this.getOpenAmount(bill), 0);
    }

    currentPagePaymentHeldAmount(): number {
        return this.allBills
            .filter(bill => !!bill.paymentHold)
            .reduce((total, bill) => total + this.getOpenAmount(bill), 0);
    }

    currentPageCount(predicate: (bill: Bill) => boolean): number {
        return this.allBills.filter(predicate).length;
    }

    formatMoney(amount: number | undefined, currencyCode: string = this.reportCurrencyCode): string {
        return `${currencyCode || ''} ${Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: currencyFractionDigits(currencyCode || 'SAR'), maximumFractionDigits: currencyFractionDigits(currencyCode || 'SAR') })}`;
    }

    statusSeverity(status: string | undefined): 'success' | 'info' | 'warn' | 'danger' | 'secondary' {
        if (status === 'PAID') return 'success';
        if (status === 'POSTED' || status === 'APPROVED' || status === 'APPLIED') return 'success';
        if (status === 'DRAFT' || status === 'SUBMITTED') return 'info';
        if (status === 'PARTIALLY_PAID') return 'warn';
        if (status === 'UNPAID' || status === 'ON_HOLD' || status === 'CANCELLED' || status === 'REVERSED' || status === 'VOIDED') return 'danger';
        return 'secondary';
    }

    openPreview(bill: Bill) {
        this.previewBill = bill;
        this.isPreviewVisible = true;
    }

    viewBill(bill: Bill) {
        this.router.navigate(['/accounts/enterprise/payables/generated-bills/view', bill.billId]);
    }

    createNonPoDraft() {
        this.router.navigate(['/accounts/enterprise/payables/generated-bills/non-po-draft']);
    }

    canEditDraftBill(bill: Bill): boolean {
        return !this.isConsolidatedReadOnly
            && this.canEditBill
            && canEditNonPoBillDraft(bill, this.sessionStorageService.getCompany()?.id);
    }

    editBill(bill: Bill) {
        if (!this.canEditDraftBill(bill)) return;
        this.router.navigate(['/accounts/enterprise/payables/generated-bills/non-po-draft', bill.billId]);
    }

    canPostBill(bill: Bill): boolean {
        return !this.isConsolidatedReadOnly
            && this.canEditBill
            && bill.documentStatus === 'APPROVED'
            && bill.postingStatus !== 'POSTED'
            && !bill.paymentHold;
    }

    postBill(bill: Bill) {
        if (!this.canPostBill(bill)) {
            this.messageService.add({ severity: 'warn', summary: 'Not ready', detail: 'Bill must be approved, unposted, and not on payment hold.' });
            return;
        }
        this.isLoading = true;
        this.accountsService.postBill(bill.billId!, { source: 'PORTAL_BILL_LIST', comment: 'Posted from vendor bills list' }).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Posted', detail: `Bill ${bill.billNumber || bill.billId} posted.` });
                this.applyFilters();
            },
            error: (err) => {
                this.messageService.add({ severity: 'error', summary: 'Post failed', detail: err?.error?.message || 'Could not post bill.' });
                this.isLoading = false;
            }
        });
    }


    downloadBill(bill: Bill) {
        if (!bill.billId || !this.documentActions.begin(bill.billId)) return;
        this.accountsService.downloadBillDocument(bill.billId).pipe(
            finalize(() => this.documentActions.end(bill.billId))
        ).subscribe({
            next: pdf => this.accountsService.downloadPdfDocument(pdf, 'vendor-bill', bill.billNumber, bill.billId, bill.postingStatus),
            error: err => this.messageService.add({ severity: 'error', summary: 'Document unavailable', detail: err?.status === 404 ? 'Original unavailable: no stored bill PDF exists.' : 'The vendor bill PDF is unavailable.' })
        });
    }

    exportToExcel() {
        if (this.allBills.length === 0) {
            this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'There is no data to export.' });
            return;
        }
        const worksheet = XLSX.utils.json_to_sheet(this.allBills.map(i => ({
            Vendor: this.crmPartyContext.displayName(i),
            Contact: this.crmPartyContext.contactDisplayName(i),
            'Bill #': i.billNumber,
            'Bill Date': i.billDate,
            'Total Amount': i.totalAmount,
            Currency: i.country?.currencyCode,
            Status: this.getBillStatus(i),
            'Document Status': i.documentStatus,
            'Posting Status': i.postingStatus,
            'Match Status': i.matchStatus,
            'Applied Vouchers': i.vouchers?.map(r => r.voucherNumber).join(', ')
        })));
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "GeneratedBillsExport");
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        // Create a blob from the workbook
        const blob = new Blob([XLSX.write(buffer, { bookType: 'xlsx', type: 'array' })],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Create a URL for the blob
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.target = '_blank';
        a.click();

        // Clean up by revoking the URL
        window.URL.revokeObjectURL(url);
    }

    editBillLine(billLine: BillLine) {
        // Implement logic to edit an bill line, e.g., open a dialog
        console.log('Editing bill line:', billLine);
    }

    generateVoucher() {
        if (this.isConsolidatedReadOnly) {
            this.messageService.add({ severity: 'warn', summary: 'Read-only scope', detail: 'Switch to a legal company to generate vouchers.' });
            return;
        }
        if (!this.selectedBills || this.selectedBills.length === 0) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select at least one bill' });
            return;
        }
        // Check if any selected bill is already fully paid
        if (this.selectedBills.some(inv => this.getBillStatus(inv) === 'PAID')) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'One or more selected bills are already fully paid.' });
            return;
        }
        this.isLoading = true;
        this.accountsService.generateVoucherFromBills(this.selectedBills).subscribe({
            next: (voucher) => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `Voucher #${voucher.voucherNumber} generated successfully.` });
                this.selectedBills = []; // Clear selection
                this.applyFilters(); // Refresh data
            },
            error: (err) => {
                this.messageService.add({ severity: 'error', summary: 'Voucher Error', detail: 'Error creating voucher: ' + (err.error?.message || 'Unknown error') });
                this.isLoading = false;
            }
        });
    }

}
